module.exports = __webpack_public_path__ + "static/media/heatmap.ac3abe88.png";